<template>
  <div>
    <div
      class="flex flex-col items-center justify-center"
      :class="{ 'lg:flex-row': !isMobile }"
    >
      <img
        src="../../public/logo-grand-union.svg"
        alt="Logo Grand Union"
        class="w-24 h-24"
      />
      <div
        class="mt-4 flex flex-col items-center justify-center"
        :class="{ 'lg:items-start lg:ml-8': !isMobile }"
      >
        <h1
          class="mb-4 text-base font-medium text-grey-medium"
          :class="{
            'lg:items-start  lg:text-2xl ': !isMobile,
          }"
        >
          Quem ama, serve.
        </h1>
        <p
          class="text-center text-grey-medium font-normal text-sm"
          :class="{ 'lg:text-left lg:text-xl': !isMobile }"
        >
          “Cremos que a transformação social acontece através do conhecimento do
          evangelho.”
          <strong
            class="block lg:inline-block text-blue font-medium text-base"
            :class="{ 'lg:text-left lg:text-xl': !isMobile }"
            >PR. ISMAEL NASCIMENTO.</strong
          >
        </p>
      </div>
    </div>

    <div
      class="flex flex-col items-center justify-center mt-6 space-y-4"
      :class="{ 'lg:items-start': !isMobile }"
    >
      <p
        class="max-w-xs text-center text-sm"
        :class="{ 'lg:text-left lg:max-w-full lg:text-xl': !isMobile }"
      >
        Você tem o poder de salvar vidas ao redor do mundo.
        <br />
        <strong class="font-medium text-sm" :class="{ 'lg:text-xl': !isMobile }"
          >Apoie a nossa causa!</strong
        >
      </p>
      <p class="text-center mt-4 text-sm" :class="{ 'lg:text-xl': !isMobile }">
        Escolha como
        <strong
          class="text-blue font-medium text-sm"
          :class="{ 'lg:text-xl': !isMobile }"
          >apoiar</strong
        >:
      </p>

      <div
        class="block"
        :class="{
          'lg:flex lg:space-x-4 lg:items-center lg:w-full lg:justify-center':
            !isMobile,
        }"
      >
        <!-- Grupo de radio buttons -->
        <div class="flex space-x-4 items-center justify-center">
          <div
            v-for="(percentage, index) in percentages"
            :key="index"
            class="flex items-center justify-center text-sm"
            :class="{ 'lg:text-xl': !isMobile }"
          >
            <input
              type="radio"
              :id="`percentage-${index}`"
              :value="percentage"
              v-model="selectedPercentage"
              @click="handleRadioClick(percentage)"
              class="cursor-pointer"
            />
            <!-- Adicionando manipulador de clique para o rótulo -->
            <label
              :for="`percentage-${index}`"
              class="ml-2 cursor-pointer"
              @click="selectPercentage(percentage)"
            >
              <span>{{ percentage }}%</span>
            </label>
          </div>
        </div>

        <!-- Grupo do input customPercentage -->
        <div
          class="flex space-x-2 mt-4 text-sm"
          :class="{
            'lg:mt-0 lg:text-xl': !isMobile,
          }"
        >
          <label>Escolha a porcentagem:</label>
          <input
            v-model="customPercentage"
            type="text"
            min="0"
            max="100"
            maxlength="3"
            pattern="^(?:100|[1-9]?[0-9])$"
            class="border-0 border-b border-gray-medium focus:border-gray-medium w-16 text-sm"
            :class="{ 'lg:text-xl': !isMobile }"
            @input="handleCustomInput"
            @keypress="validateNumericInput"
            @blur="normalizeCustomPercentage"
          />
          <span>%</span>
        </div>
      </div>
    </div>

    <div
      class="mt-8 flex justify-center items-center"
      :class="{ 'lg:justify-end': !isMobile }"
      v-if="!isMobile"
    >
      <div class="lg:block">
        <button
          class="py-3 px-8 rounded-lg bg-blue text-white font-medium text-lg border-none cursor-pointer"
          @click="onSubmitPercentagem"
        >
          Apoiar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrandUnionFields',

  props: {
    decoded: Object,
    isMobile: Boolean,
    valorContribuicao: Number,
  },

  data() {
    return {
      percentages: [3, 5, 7, 10],
      selectedPercentage: null,
      customPercentage: this.valorContribuicao || null,
    };
  },
  methods: {
    handleRadioClick(percentage) {
      if (this.percentages.includes(percentage)) {
        this.customPercentage = percentage;
        this.$emit('onSelectedCustomPercentage', {
          customPercentage: this.customPercentage,
        });
        return;
      }
      this.handleCustomInput();
    },
    handleCustomInput() {
      this.$emit('onSelectedCustomPercentage', {
        customPercentage: this.customPercentage || null,
        selectedPercentage: null,
      });
    },
    selectPercentage(value) {
      this.selectedPercentage = value;
      this.clearCustomPercentage();
    },
    clearCustomPercentage() {
      this.customPercentage = null;
    },
    onSubmitPercentagem() {
      this.$emit('selectPercentagem', {
        customPercentage: this.customPercentage,
        selectedPercentage: this.selectedPercentage,
      });
    },
    validateNumericInput(event) {
      const inputChar = String.fromCharCode(event.charCode);
      if (!/^\d*\.?\d*$/.test(inputChar)) {
        event.preventDefault();
      }
    },
    normalizeCustomPercentage() {
      const parsedValue = parseFloat(this.customPercentage);
      this.customPercentage = isNaN(parsedValue)
        ? 0
        : Math.min(100, Math.max(0, parsedValue));
    },
  },
};
</script>

<style scoped lang="scss"></style>
